import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PlacesProvider } from "./context/PlacesContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import Explore from "./pages/Explore";
import Reviews from "./pages/Reviews";
import PlaceDetail from "./pages/PlaceDetail";
import Neighborhood from "./pages/Neighborhood";
import City from "./pages/City";
import Favourites from "./pages/Favourites";
import Guide from "./pages/Guide";
import GuideDetail from "./pages/GuideDetail";
import Awards from "./pages/Awards";
import Videos from "./pages/Videos";
import About from "./pages/About";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <PlacesProvider>
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/place/:slug" element={<PlaceDetail />} />
              <Route path="/neighborhood/:slug" element={<Neighborhood />} />
              <Route path="/city/:slug" element={<City />} />
              <Route path="/favourites" element={<Favourites />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/guide/:slug" element={<GuideDetail />} />
              <Route path="/awards" element={<Awards />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
        </PlacesProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
